import apiClient from '@/services/axios'

export async function put(lessonId, payload) {
  var response = await apiClient.put('/lessons/' + lessonId, payload)
  if (response) {
    return response.data
  }

  throw new Error('Unable to update Lesson.')
}
